import React,{useEffect,useRef} from 'react';
import {createPortal} from 'react-dom';
export default function AgendaRangePanel({title,items=[],onClose,onOpenDay,onCreate,onEventClick}){
 const ref=useRef(null);
 useEffect(()=>{
  const previous=document.activeElement;
  const previousOverflow=document.body.style.overflow;
  document.body.style.overflow='hidden';
  ref.current?.querySelector('button')?.focus();
  const key=e=>{
   if(e.key==='Escape'){e.preventDefault();onClose();}
   if(e.key==='Tab'){
    const controls=[...ref.current.querySelectorAll('button:not(:disabled),a[href]')];
    if(!controls.length)return;
    if(e.shiftKey&&document.activeElement===controls[0]){e.preventDefault();controls[controls.length-1].focus();}
    else if(!e.shiftKey&&document.activeElement===controls[controls.length-1]){e.preventDefault();controls[0].focus();}
   }
  };
  const panel=ref.current;panel.addEventListener('keydown',key);
  return ()=>{document.body.style.overflow=previousOverflow;panel.removeEventListener('keydown',key);if(previous?.isConnected)previous.focus();};
 },[onClose]);
 return createPortal(<div className="agenda-range-backdrop" onClick={e=>{if(e.target===e.currentTarget)onClose();}}>
  <section className="agenda-range-panel" role="dialog" aria-modal="true" aria-label={title} ref={ref}>
   <header><div><h2>{title}</h2><p>{items.length} reservas</p></div><button type="button" onClick={onClose} aria-label="Cerrar detalle del día">×</button></header>
   <div className="agenda-range-panel-list">{items.length?items.map((item,i)=><button type="button" className="agenda-range-item" key={item.id||i} onClick={()=>{onClose();onEventClick?.(item.event);}} style={{borderLeftColor:item.accent}}>
    <span>{item.time}</span><strong>{item.client}</strong><span>{item.service}{item.worker?` · ${item.worker}`:''}</span><small>{item.status}</small>
   </button>):<p>No hay reservas para este día.</p>}</div>
   <footer>{onOpenDay&&<button type="button" onClick={onOpenDay}>Abrir día</button>}{onCreate&&<button type="button" onClick={onCreate}>Crear reserva</button>}</footer>
  </section>
 </div>,document.body);
}
